export default __webpack_public_path__ + "static/media/p20-tip-box-open.0dca2069.svg";